import React, { useEffect } from 'react';

import { Loader } from '.';
import { useAppSelector } from 'redux/hooks';
import {IframePage} from "../types/iframe";
import {withParamsFrame} from "../HOCs";

const Marketplaces: React.FC<IframePage> = ({ params }) => {
    const [httpParams] = React.useState(params);
    const [loaded, setLoaded] = React.useState(false);

    const iframe = React.useRef<HTMLIFrameElement | null>(null);

    const { sellerId } = useAppSelector(({ users, sellers, appOptions }) => ({
        accessToken: users.currentUser.data.accessToken,
        sellerId: sellers.currentSeller.info.data?.id,
        currentLanguage: appOptions.language
    }))

    useEffect(() => {
        if(iframe.current) {
            var cssLink = document.createElement("link");
            cssLink.href = "google.com";
            cssLink.rel = "stylesheet";
            cssLink.type = "text/css";
            window.frames['marketplaces' as any].document.head.appendChild(cssLink);
        }
    }, [iframe])

    return (
        <>
            <div className='xs:mx-3'>
                <iframe ref={iframe} name="marketplaces" className={`${!loaded ? 'min-h-[auto]' : 'page-iframe'}`} src={`https://lk.market/${sellerId}/marketplaces${httpParams}`}
                    title="Marketplaces"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}

                    onLoad={() => setLoaded(true)}
                ></iframe>
            </div>
            {
                !loaded && <Loader />
            }
        </>
    );
};

export default withParamsFrame(Marketplaces);
